import { Component, OnInit } from '@angular/core';
import { BUSINESS_CONST } from 'src/app/shared/constants/business.constants';
import {
  ProductsBiocatchEnum,
  StepBiocatchEnum,
} from 'src/app/shared/enums/biocatchContext.enum';
import { OpEnum } from 'src/app/shared/enums/op.enum';
import {
  OccupationSecondHeadlineModel,
  OfficeModel,
} from 'src/app/shared/models/abre-cuentas.model';
import { OccupationModel } from 'src/app/shared/models/occupation.model';
import { IProductsModel } from 'src/app/shared/models/products.model';
import { AbreCuentasService } from 'src/app/shared/services/abre-cuentas/abre-cuentas.service';
import { BitacoraService } from 'src/app/shared/services/bitacora/bitacora.service';
import { CaptureService } from 'src/app/shared/services/capture/capture.service';
import { CopyService } from 'src/app/shared/services/copies/copy.service';
import { BioCatchService } from 'src/app/shared/services/external/biocatch/biocatch.service';
import { FirmlyApprovedService } from 'src/app/shared/services/firmly-approved/firmly-approved.service';
import { HeaderService } from 'src/app/shared/services/header/header.service';
import { ValidationHelperService } from 'src/app/shared/services/helpers/validation-helper.service';
import { IncomesService } from 'src/app/shared/services/incomes/incomes.service';
import { NavigationService } from 'src/app/shared/services/navigation/navigation-onboarding.service';
import { ParametersService } from 'src/app/shared/services/parameters/parameters.service';
import { PostValidateService } from 'src/app/shared/services/post-validate/post-validate.service';
import { ProductLoaderService } from 'src/app/shared/services/product-loader/product-loader.service';
import { TaggingService } from 'src/app/shared/services/tagging/tagging.service';
import { DaliService, IPageLoadModel } from '@dali/tagger-ng8';
import {
  PAGEVIEW as PAGEVIEW_FA,
  CHANNEL as CHANNEL_FA,
  COUNTRY as COUNTRY_FA,
  BUSINNESS as BUSINNESS_FA,
  ENVIRONMENT as ENVIRONMENT_FA,
  FAMILY as FAMILY_FA,
  SUBFAMILY as SUBFAMILY_FA,
  PRODUCT as PRODUCT_FA,
} from 'src/app/shared/constants/dali-fa-tc.constants';
import {
  EVENT as EVENT_FA_LD,
  PAGEVIEW as PAGEVIEW_FA_LD,
} from 'src/app/shared/constants/dali-fa-ld.constants';
import { ChannelCommunicatorService } from 'src/app/shared/services/communicator/channel-communicator/channel-communicator.service';

/**
 * Occupation select module for tc
 *
 * @export
 * @class OccupationTcComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-occupation-tc-component',
  templateUrl: './occupation-tc.component.html',
  styleUrls: ['./occupation-tc.component.scss'],
})
export class OccupationTcComponent implements OnInit {
  occupations: any[];
  selectedOccupation: any;
  documentInfo: any;
  selectOccupation = false;
  dataClient: any;
  selectedProduct: IProductsModel;
  officeInfo: OfficeModel;
  tittle: any;
  postLogin: boolean;
  sinOcupacion = false;
  has_second_headline: any;
  dataDocument: any;
  back: any;
  /**
   * Summary Constructor of the component.
   * Description Initialize services and Enum that is used in the Component
   * s@param navigationService
   * @param CaptureService
   * @param abreCuentasService
   * @param latamItLoaderService
   */
  constructor(
    private navigationService: NavigationService,
    private captureService: CaptureService,
    private validationHelperService: ValidationHelperService,
    private abreCuentasService: AbreCuentasService,
    private taggingService: TaggingService,
    private headerService: HeaderService,
    private parameterService: ParametersService,
    public copyService: CopyService,
    private productLoaderService: ProductLoaderService,
    private postvalidate: PostValidateService,
    private bitacoraService: BitacoraService,
    private incomesService: IncomesService,
    private bioCatchService: BioCatchService,
    private firmlyApprovedService: FirmlyApprovedService,
    private channelCommunicatorService: ChannelCommunicatorService,
    private daliService: DaliService,
  ) {
    this.headerService.show(true, true, true);
  }

  /**
   * Summary Initialize attribute occupations with predefined list loaded in Pre-Login
   *
   * @memberof OccupationTcComponent
   */
  ngOnInit() {
    this.sendTagging('init');
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendOccupationPageLoad();
    }
    this.previous();
    const product = this.abreCuentasService.getproductSelected()
      .product_code as ProductsBiocatchEnum;
    this.bioCatchService.changeContext(
      StepBiocatchEnum.captura,
      product,
      this.bioCatchService.isVivCn(product),
    );
    this.has_second_headline = this.abreCuentasService.getSecondHeadline();
    this.selectedOccupation =
      typeof this.has_second_headline === 'undefined' ||
        !this.has_second_headline.has_second_headline
        ? OccupationModel
        : OccupationSecondHeadlineModel;
    this.selectedOccupation =
      typeof this.has_second_headline === 'undefined' ||
        !this.has_second_headline.has_second_headline
        ? this.abreCuentasService.getOccupationSelected()
        : this.abreCuentasService.getOccupationSelectedSecondHeadline();
    this.dataClient = this.abreCuentasService.getCustomerData();
    this.selectedOccupation = this.abreCuentasService.getSecondHeadline()
      ? this.abreCuentasService.getOccupationSelectedSecondHeadline()
      : this.abreCuentasService.getOccupationSelected();
    this.selectedProduct = this.abreCuentasService.getproductSelected();
    this.postLogin = this.abreCuentasService.getPostlogin();
    this.occupations = this.optionsMultiproduct()
      ? this.parameterService.getSetting(OpEnum.OCCUPATION_LOAN)
      : this.parameterService.getSetting(OpEnum.OCCUPATIONS_LIST_TC);
    this.occupations =
      this.occupations === undefined
        ? []
        : this.occupations.map(occupation => ({
          id: `radio-${occupation.name}`,
          label: occupation.name,
          value: JSON.stringify(occupation),
          checked:
            !!this.selectedOccupation &&
            this.selectedOccupation.name === occupation.name,
        }));
    if (!this.abreCuentasService.viewOptionMultiProduct) {
      if (
        !this.selectedOccupation.id &&
        this.abreCuentasService.getProspectResponse().is_client
      ) {
        this.selectedOccupation = this.occupations.find(
          occupation =>
            occupation.name ===
            this.abreCuentasService.getCustomerData().basic.profession,
        );
        if (this.selectedOccupation) {
          this.has_second_headline
            ? this.abreCuentasService.setOccupationSelectedSecondHeadline(
              this.selectedOccupation,
            )
            : this.abreCuentasService.setOccupationSelected(
              this.selectedOccupation,
            );
        } else {
          this.selectedOccupation = this.has_second_headline
            ? this.abreCuentasService.getOccupationSelectedSecondHeadline()
            : this.abreCuentasService.getOccupationSelected();
        }
        if (this.selectedOccupation.name !== this.occupations) {
          this.occupations = this.occupations.map(occupation => ({
            id: `radio-${occupation.name}`,
            label: occupation.name,
            value: JSON.stringify(occupation),
            checked:
              this.selectedOccupation &&
              this.selectedOccupation.name === occupation.name,
          }));
        }
      }
    }

    this.documentInfo = {
      document_number: this.has_second_headline
        ? this.abreCuentasService.getBasicInfoSecondHeadline()
          .doc_number_second_headline
        : this.abreCuentasService.getDocumentInfo().document_number,
      firstname: this.has_second_headline
        ? this.abreCuentasService.getBasicInfoSecondHeadline()
          .name_second_headline
        : this.abreCuentasService.getDocumentInfo().firstname,
      primary_lastname: this.has_second_headline
        ? this.abreCuentasService.getBasicInfoSecondHeadline()
          .lastname_second_headline
        : this.abreCuentasService.getDocumentInfo().primary_lastname,
    };
  }

  /**
   * Summary Load in selectedOccupation, the selected item from Occupations List
   *
   * @param occupationselect Object type-Occupation Model
   */
  activeOccupation(event: any) {
    const radio = this.occupations.find(e => e.value === event.value);
    if (!radio) {
      return;
    }
    this.selectedOccupation = JSON.parse(radio.value);
    this.has_second_headline
      ? this.abreCuentasService.setOccupationSelectedSecondHeadline(
        this.selectedOccupation,
      )
      : this.abreCuentasService.setOccupationSelected(this.selectedOccupation);
    const tagPageName = this.navigationService.getCurrentStep().tag_name;
    this.taggingService.pageTagEventOccupation(
      this.selectedOccupation.name,
      tagPageName,
    );
  }

  /**
   * according to selected ocupation continue with next in flow
   *
   * @memberof OccupationTcComponent
   */
  next() {
    this.sendTagging('next', 'center', '2');
    if (this.taggingService.isFirmlyAprovedMono()) {
      this.sendContinueButtonEvent();
    }
    let strTypeProduct =
      this.abreCuentasService.getproductSelected().product_type;
    if (
      !this.firmlyApprovedService.isEmpty() &&
      this.firmlyApprovedService.getOfferType_Channel() === 'En_firme'
    ) {
      this.callProspectOcupation();
    }
    switch (strTypeProduct) {
      case BUSINESS_CONST.PRODUCT_TYPE_LIVING:
        this.switchCode();
        break;
      case BUSINESS_CONST.MULTI:
        this.redirectToMulti();
        break;
      case BUSINESS_CONST.PRODUCT_TYPE_LOAN:
        this.navigationService.nextStep('200');
        break;
      default:
        this.callIncomes();
        break;
    }
  }

  callProspectOcupation() {
    const body = {
      occupation_id: this.selectedOccupation.id.toString(),
      ciiu: this.selectedOccupation.ciiu,
      document_id: this.documentInfo.document_number,
    };
    const parms = {
      main_activity_id: this.selectedOccupation.id,
      first_name: this.abreCuentasService.getDocumentInfo().firstname,
      first_surname: this.abreCuentasService.getDocumentInfo().primary_lastname,
      product_type: this.abreCuentasService.getproductSelected().product_type,
    };
    this.captureService
      .sendProspectOccupationWithBody(body, parms)
      .then((resp: any) => {
        if (!resp) {
          return;
        }
        this.abreCuentasService.setinfoInferredIncomes(resp.body);
      });
  }

  callIncomes(): string | void {
    this.bitacoraService.saveDataInBitacora('Ini_loading_Incomes');
    this.incomesService.callIncomes().then(() => {
      if (!this.abreCuentasService.getPostlogin()) {
        this.switchCode();
      } else if (
        this.abreCuentasService.getPostlogin() &&
        !this.validationHelperService.validateMailPhone()
      ) {
        this.navigationService.navigateToGeneralInformation('512');
      } else {
        this.redirectToMulti();
      }
    });
    this.bitacoraService.saveDataInBitacora('Out_loading_Incomes');
  }

  redirectToMulti() {
    let arrProductMulti = this.abreCuentasService.getProductsSelects();
    let strNextStop = '201';
    if (this.abreCuentasService.getLoanSelected()) {
      strNextStop = '203';
    }
    if (
      arrProductMulti.filter(
        product => product.flow === BUSINESS_CONST.PRODUCT_TYPE_FREE,
      ).length > 0
    ) {
      strNextStop = '200';
    }
    this.navigationService.nextStep(strNextStop);
  }

  switchCode() {
    switch (this.selectedOccupation.id) {
      case 1:
        this.navigationService.nextStep('201');
        break;
      case 2:
        this.navigationService.nextStep('202');
        break;
      case 5:
        this.navigationService.nextStep('200');
        break;
      default:
        break;
    }
  }

  redirecttoOccupationflow() {
    let nextCode: string;
    if (!this.abreCuentasService.getCustomerData()) {
      return;
    }
    const configClient = this.parameterService.getSetting(
      OpEnum.CONFIG_CLIENT_EXIST,
    );
    const nowDate = new Date();
    const lastUpdateDate = new Date();
    lastUpdateDate.setTime(
      this.abreCuentasService.getCustomerData().basic.last_update_date,
    );
    lastUpdateDate.setDate(lastUpdateDate.getDate() + configClient.days_update);
    nextCode = lastUpdateDate.getTime() < nowDate.getTime() ? '200' : '201';
    if (
      this.abreCuentasService.getCustomerData().basic.profession !==
      this.selectedOccupation.name
    ) {
      return (nextCode = '203');
    }
    if (!this.validationHelperService.isValidExistingClient()) {
      this.redirectToMulti();
    }
  }

  optionsMultiproduct() {
    if (
      this.abreCuentasService
        .getProductsSelects()
        .filter(fil => fil.flow === 'loan').length > 0
    ) {
      return true;
    } else {
      return false;
    }
  }

  previous() {
    if (this.abreCuentasService.haveLoan) {
      this.back = '201';
    } else {
      this.back = '200';
    }
  }

  /* ------------- Taggeo ------------- */

  /* ------------ Taggeo - PageLoad ------------ */
  sendOccupationPageLoad(): void {
    const isApp = this.channelCommunicatorService.getChannelId() === '141';
    const productsType = {
      ORD: 'LD',
      TCR: 'TC',
    };

    const pageName = {
      TCR: PAGEVIEW_FA.pv3pageName.value,
      ORD: PAGEVIEW_FA_LD.pv4pageName.value,
      CRP: PAGEVIEW_FA_LD.pv4pageName.value,
    };
    const changes: IPageLoadModel[] = [
      {
        path: PAGEVIEW_FA.pv3pageName.path,
        value: `${isApp ? CHANNEL_FA.superapp : CHANNEL_FA.homeBanking}:${COUNTRY_FA.co}:${BUSINNESS_FA.pf}:${ENVIRONMENT_FA.loggeado}:${FAMILY_FA.services}:${SUBFAMILY_FA.request}:${PRODUCT_FA.request}:${pageName[this.abreCuentasService.getProductsSelects()[0].product]}`,
      },
      {
        path: PAGEVIEW_FA.pv3pageFamily.path,
        value: PAGEVIEW_FA.pv3pageFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv3subFamily.path,
        value: PAGEVIEW_FA.pv3subFamily.value,
      },
      {
        path: PAGEVIEW_FA.pv3pageAction.path,
        value: PAGEVIEW_FA.pv3pageAction.value,
      },
      {
        path: PAGEVIEW_FA.pv3pageid.path,
        value: OccupationTcComponent.name,
      },
      {
        path: PAGEVIEW_FA.pv3transactionName.path,
        value: `${PAGEVIEW_FA.pv3transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`,
      },
      {
        path: PAGEVIEW_FA.pv3transactionTransactionStep.path,
        value: PAGEVIEW_FA.pv3transactionTransactionStep.value,
      },
    ];
    this.taggingService.addCommonPageChanges(changes);
    this.daliService.pageLoad(changes);
  }

  /* -------------- Taggeo - Events ------------- */
  sendBackButtonEvent(): void {
    this.sendTagging('prev', 'center', '1');
    if (!this.taggingService.isFirmlyAprovedMono()) {
      return;
    }
    const data = [
      {
        path: EVENT_FA_LD.pv4E1setData.pv4E1transactionTransactionStep.path,
        value: EVENT_FA_LD.pv4E1setData.pv4E1transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv4E1setData.pv4E1transactionName.path,
        value: `${EVENT_FA_LD.pv4E1setData.pv4E1transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv4E1customLabel,
    };
    this.daliService.trackEvent(event, data);
  }

  sendContinueButtonEvent(): void {
    const data = [
      {
        path: EVENT_FA_LD.pv4E2setData.pv4E2transactionTransactionStep.path,
        value: EVENT_FA_LD.pv4E2setData.pv4E2transactionTransactionStep.value,
      },
      {
        path: EVENT_FA_LD.pv4E2setData.pv4E2transactionName.path,
        value: `${EVENT_FA_LD.pv4E2setData.pv4E2transactionName.value.slice(0, -2)}${this.taggingService.getProductFlow()}`, // cambiar valor segun sea LD o TC
      },
      {
        path: EVENT_FA_LD.pv4E2setData.pv4E3clientElegibility.path,
        value: this.selectedOccupation.name,
      },
    ];
    const event = {
      category: {
        module: EVENT_FA_LD.customCategory.module.body,
        type: EVENT_FA_LD.customCategory.type.button,
        position: EVENT_FA_LD.customCategory.position.center,
      },
      action: EVENT_FA_LD.customAction.click,
      label: EVENT_FA_LD.pv4E2customLabel,
    };
    this.daliService.trackEvent(event, data);
  }
  sendTagging(value: any, position?: string, event?: string) {
    const page = '5';
    const occupation = this.selectedOccupation ? this.selectedOccupation.name : '' ;
    const extras = {
      object: 'clientElegibility',
      value: occupation,
      pageValue: 'OccupationTc',
    };
    this.taggingService.sendTaggValues(value, page, position, event, extras);
  }
}
